module.exports = __webpack_public_path__ + "static/media/b10@2x.02bf6a97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/floorplates/b10@2x.png
// module id = 216
// module chunks = 0